import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';

export default function FeuturedProduct(props) {
  return (
    <Card sx={{ maxWidth: 545 }}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="260"
          image={"/assets/article-images/" + props.item.src}
          alt={props.item.label}
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            {props.item.label}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {props.item.description}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}